import HistoryRiskScore from './HistoryRiskScore'

export default HistoryRiskScore
